import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { DashSelection } from '../app/app.model';
import Datepicker from 'vuejs-datepicker';
import { de } from 'vuejs-datepicker/dist/locale'

@Component(
    {
        name: 'HeaderNavigation',
        components: {
            Datepicker
        }
    })
export default class HeaderNavigationComponent extends Vue {
    @Prop({required: true})
    selection!: DashSelection;

    private datepickerDE: any = de;
}